import React, { useCallback, useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { Layout } from '../components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { useAuth } from '../contexts/AuthContext';
import { WorkersTab } from '../components/godziny/WorkersTab';
import { PendingTab } from '../components/godziny/PendingTab';
import { SummaryTab } from '../components/godziny/SummaryTab';
import { LegacyArchiveCard } from '../components/godziny/LegacyArchiveCard';
import { godzinyApi } from '../components/godziny/shared';

export default function Godziny() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const canManage = user?.role === 'admin' || user?.role === 'asystent_biura' || (user?.permissions || []).includes('kadry_manage');
  const refreshCount = useCallback(() => godzinyApi.pendingCount().then(setCount).catch(() => {}), []);
  useEffect(() => { refreshCount(); }, [refreshCount]);
  return (
    <Layout>
      <div className="p-4 md:p-8 lg:p-12 space-y-6" data-testid="godziny-page">
        <h1 className="text-2xl md:text-4xl font-manrope font-bold text-[var(--crm-text-primary)] tracking-tight flex items-center gap-3">
          <Clock className="w-8 h-8 text-[#FF6B35]" />Godziny pracy
        </h1>
        {user?.role === 'admin' && <LegacyArchiveCard />}
        <Tabs defaultValue="pending">
          <TabsList className="bg-[var(--crm-bg-panel)] flex-wrap h-auto max-w-full">
            <TabsTrigger value="pending" data-testid="tab-pending">Do akceptacji{count > 0 && <span className="ml-2 px-1.5 rounded-full bg-[#FF6B35] text-white text-xs" data-testid="pending-count-badge">{count}</span>}</TabsTrigger>
            <TabsTrigger value="workers" data-testid="tab-workers">Pracownicy</TabsTrigger>
            <TabsTrigger value="summary" data-testid="tab-summary">Zestawienie miesięczne</TabsTrigger>
          </TabsList>
          <TabsContent value="pending"><PendingTab canManage={canManage} onCountChange={refreshCount} /></TabsContent>
          <TabsContent value="workers"><WorkersTab canManage={canManage} /></TabsContent>
          <TabsContent value="summary"><SummaryTab /></TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
